// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a556e566","455":"635b5b32","977":"65598933"}[chunkId] + ".chunk.js";
};